export const CARD_CATEGORY_MAX = 2

export const SOLUTION_CARD_CATEGORY_MAX = 3

export const CARD_SHELL_CLASS =
  'rounded-2xl border border-white-200 bg-white-50 px-6 py-[22px] shadow-[0_0_4px_-1px_rgb(0_0_0/8%),0_0_12px_-4px_rgb(0_0_0/16%)]'
